var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1009 12.6667L19.0001 16.7675L14.8992 12.6667L12.6667 14.8992L16.7676 19L12.6667 23.1008L14.8992 25.3333L19.0001 21.2325L23.1009 25.3333L25.3334 23.1008L21.2326 19L25.3334 14.8992L23.1009 12.6667ZM19.0001 3.16666C10.2442 3.16666 3.16675 10.2442 3.16675 19C3.16675 27.7558 10.2442 34.8333 19.0001 34.8333C27.7559 34.8333 34.8334 27.7558 34.8334 19C34.8334 10.2442 27.7559 3.16666 19.0001 3.16666ZM19.0001 31.6667C12.0176 31.6667 6.33341 25.9825 6.33341 19C6.33341 12.0175 12.0176 6.33332 19.0001 6.33332C25.9826 6.33332 31.6667 12.0175 31.6667 19C31.6667 25.9825 25.9826 31.6667 19.0001 31.6667Z",
    fill: "#8F0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.14288306070fc7c1b75c66e9509e0c09.svg";
export { ForwardRef as ReactComponent };